module.exports = __webpack_public_path__ + "static/img/104154.6f55aa3e.png";